import React from 'react'
import { useSelector } from 'react-redux'
import selectPageParameters from 'redux/selectors/selectPageParameters'
import SmartSearchHeader from 'components/smartsearch/Header'

const Header = () => {
  const params = useSelector(selectPageParameters)
  const flavours = params?.flavours ?? []

  return <SmartSearchHeader flavours={flavours} />
}

export default Header
